// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import FormWithCaptchaController from "./form_with_captcha_controller";

application.register("form-with-captcha", FormWithCaptchaController);

import SubnavController from "./subnav_controller";

application.register("subnav", SubnavController);
